import { store } from "@/store";
import Debugger from "../console/debugger";
import EventBus from "../event_bus";
import DEFINE from "../painter/define";
import PainterProxy from "../painter/proxy";
import { TOOLS } from "./tools";
export default class PaintTool {
    _confirmDialog = null;

    constructor(confirm) {
        this._confirmDialog = confirm;
    }

    getToolFunction() {
        return [
            {
                key: TOOLS.SELECTION.TOOL,
                event: this.useSelection()
            },
            {
                key: TOOLS.PEN.TOOL,
                event: this.openPenBoard()
            },
            {
                key: TOOLS.HIGHLIGHTER.TOOL,
                event: this.openHighlighterBoard()
            },
            {
                key: TOOLS.LASER_POINTER.TOOL,
                event: this.openLaserPointerBoard()
            },
            {
                key: TOOLS.ERASER.TOOL,
                event: this.useEraser()
            },
            {
                key: TOOLS.CLEAR.TOOL,
                event: this.useClear()
            },
            {
                key: TOOLS.UNDO.TOOL,
                event: this.useUndo()
            },
            {
                key: TOOLS.REDO.TOOL,
                event: this.useRedo()
            }
        ]
    }

    useSelection() {
        Debugger.Instance.log("selection", "paint_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.setOperate(DEFINE.OPERATE.SELECTION);
            proxy.changeTool(null);
            proxy.getCurrentPainter().painter.isInteractive = true;
            const canvas = proxy.getCurrentPainter().painter.canvas;
            const objects = canvas.getObjects();
            for (let i = 0; i < objects.length; i++) {
                objects[i].set('selectable', true);
            }
        }
    }

    openPenBoard() {
        Debugger.Instance.log("pen", "paint_tool");
        const proxy = PainterProxy.getInstance();
        const paintBoard = EventBus.getInstance().getAppRefs().paintBoard;

        return () => {
            proxy.getMainPainter().painter.canvas.discardActiveObject();
            proxy.setOperate(DEFINE.OPERATE.PEN);
            proxy.changeTool(proxy.getDrawTool(DEFINE.OPERATE.PEN));

            if (store.nowTool == TOOLS.PEN.TOOL) {
                paintBoard.operate = DEFINE.OPERATE.PEN;
                paintBoard.updateBoard();
                paintBoard.show = true;
            }
        }
    }

    openHighlighterBoard() {
        Debugger.Instance.log("highlighter", "paint_tool");
        const proxy = PainterProxy.getInstance();
        const paintBoard = EventBus.getInstance().getAppRefs().paintBoard;

        return () => {
            proxy.getMainPainter().painter.canvas.discardActiveObject();
            proxy.setOperate(DEFINE.OPERATE.HIGHLIGHTER);
            proxy.changeTool(proxy.getDrawTool(DEFINE.OPERATE.HIGHLIGHTER));

            if (store.nowTool == TOOLS.HIGHLIGHTER.TOOL) {
                paintBoard.operate = DEFINE.OPERATE.HIGHLIGHTER;
                paintBoard.updateBoard();
                paintBoard.show = true;
            }
        }
    }

    openLaserPointerBoard() {
        Debugger.Instance.log("laserPointer", "paint_tool");
        const proxy = PainterProxy.getInstance();
        const paintBoard = EventBus.getInstance().getAppRefs().paintBoard;

        return () => {
            proxy.getMainPainter().painter.canvas.discardActiveObject();
            proxy.setOperate(DEFINE.OPERATE.LASER_POINTER);
            proxy.changeTool(proxy.getDrawTool(DEFINE.OPERATE.LASER_POINTER));

            if (store.nowTool == TOOLS.LASER_POINTER.TOOL) {
                paintBoard.operate = DEFINE.OPERATE.LASER_POINTER;
                paintBoard.updateBoard();
                paintBoard.show = true;
            }
        }
    }

    useEraser() {
        Debugger.Instance.log("eraser", "paint_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.setOperate(DEFINE.OPERATE.ERASER);
            proxy.changeTool(DEFINE.TOOLS.ERASER);
        }
    }

    useClear() {
        Debugger.Instance.log("clear", "paint_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            this._confirmDialog.showDialog(
                "提示！",
                "確定刪除當前繪圖物件？",
                () => {
                    proxy.clearAll();
                },
                null
            );
        }
    }

    useUndo() {
        Debugger.Instance.log("undo", "paint_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.undo();
        }
    }

    useRedo() {
        Debugger.Instance.log("redo", "paint_tool");
        const proxy = PainterProxy.getInstance();

        return () => {
            proxy.redo();
        }
    }
}